// This is a popover displayed either during creating or editing an arrow (relationship) between two table columns
// Allows user to define the cardinality and referential integrity between tables
// eg: One to many relation, keep all / matching rows between tables

import { CloseOutlined, JoinFull, JoinInner, JoinLeft, JoinRight } from '@mui/icons-material';
import { createSvgIcon, MenuItem, Popover, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import {
  FindCardinality,
  FindIntegrity,
  FindRowMatchId,
  FindRowUniqueId,
} from '../CommonFunctions/FindIntegrityAndCordinality';
import { rowUniqueness, rowMatch } from './constants';
import './RelationshipDefining.css';
import * as CSS from 'csstype';
import {
  RelationshipDefiningComponentProps,
  rowMat,
  rowUniq,
} from './types/RelationshipDefiningComponentInterfaces';
import { AlertColor } from '@mui/material/Alert';
import { AccessTime, CalendarToday } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import {
  AddArrow,
  RemoveArrow,
  UpdateAllArrowsInRelation,
} from '../../redux/_Dataset/dataset.action';
import HoverButton from '../Buttons/HoverButton';
import { RootState } from '../../redux';
import { fontSize } from '../..';
import ConfirmDialog from '../_dataset/ConfirmDialog';
const Boolean = createSvgIcon(
  <svg
    viewBox="0 0 76 76"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    baseProfile="full"
    enable-background="new 0 0 76.00 76.00"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        fill="#000000"
        fill-opacity="1"
        stroke-linejoin="round"
        d="M 36,23L 30,23L 30,40L 25,40L 25,23L 19,23L 19,19L 36,19L 36,23 Z M 57,40L 50,40L 50,45L 56,45L 56,49L 50,49L 50,57L 45,57L 45,36L 57,36L 57,40 Z M 44,19L 48.5,19L 32.5,57L 28,57L 44,19 Z "
      ></path>{' '}
    </g>
  </svg>,
  'Boolean',
);
const RelationshipDefiningComponent = ({
  // props
  showRelationCard,
  setShowRelationCard,
  arrowProp,
  setArrowProp,
  existingArrow,
  setExistingArrow,
  existingArrowProp,
  setExistingArrowProp,
  canEdit,
}: RelationshipDefiningComponentProps) => {
  const { selectedTables } = useSelector((state: RootState) => ({
    selectedTables: state.dataset.selectedTables,
  }));
  const [open, setOpen] = useState<boolean>(false);

  const dispatch = useDispatch();

  var textStyle: CSS.Properties = {
    whiteSpace: 'nowrap',
    padding: '0 0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 'bold',
    minWidth: '6.5rem',
  };

  var iconStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '6.5rem',
    margin: 'auto',
  };

  const [rowUniqueId1, setRowUniqueId1] = useState<number>(0);
  const [rowMatchId1, setRowMatchId1] = useState<number>(2);
  const [rowUniqueId2, setRowUniqueId2] = useState<number>(0);
  const [rowMatchId2, setRowMatchId2] = useState<number>(2);

  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [severity, setSeverity] = useState<AlertColor>('success');
  const [testMessage, setTestMessage] = useState<string>('');

  useEffect(() => {
    if (existingArrowProp && existingArrowProp.relationId) {
      let uniqueId: any = FindRowUniqueId(existingArrowProp.cardinality);
      let MatchId: any = FindRowMatchId(existingArrowProp.integrity);
      setRowUniqueId1(uniqueId.rowUniqueId1);
      setRowUniqueId2(uniqueId.rowUniqueId2);
      setRowMatchId1(MatchId.rowMatchId1);
      setRowMatchId2(MatchId.rowMatchId2);
    }
  }, [existingArrow]);

  // ====================cardinality======================

  const Cardinality: any = () => {
    if (rowUniqueId1 !== 0 && rowUniqueId2 !== 0) {
      if (rowUniqueId1 === 1 && rowUniqueId2 === 1) {
        return <span style={textStyle}>One to One</span>;
      } else if (rowUniqueId1 === 1 && rowUniqueId2 === 2) {
        return <span style={textStyle}>One to Many</span>;
      } else if (rowUniqueId1 === 2 && rowUniqueId2 === 1) {
        return <span style={textStyle}>Many to One</span>;
      } else if (rowUniqueId1 === 2 && rowUniqueId2 === 2) {
        return <span style={textStyle}>Many to Many</span>;
      }
    } else {
      return <span style={textStyle}></span>;
    }
  };
  const itemTypeIcon = (type: string) => {
    type = type.toLowerCase();
    switch (type) {
      case 'integer':
        return (
          <img src="/Integer_Icon.svg" alt="Integer" style={{ height: '15px', width: '15px' }} />
        );

      case 'text':
        return <img src="/Text_Icon.svg" alt="Text" style={{ height: '15px', width: '15px' }} />;

      case 'timestamp':
        return <AccessTime style={{ height: '15px', width: '15px' }} />;

      case 'date':
        return (
          <CalendarToday
            style={{ height: '12px', width: '12px', marginLeft: '1px', marginRight: '2px' }}
          />
        );

      case 'decimal':
        return (
          <img src="/Decimal_Icon.svg" alt="Decimal" style={{ height: '15px', width: '15px' }} />
        );
      case 'boolean':
        return <Boolean style={{ height: '15px', width: '15px' }} />;
      default:
        return null;
    }
  };
  // ===========================================
  // integrity
  // ===========================================
  const Integrity: any = () => {
    if (rowMatchId1 !== 0 && rowMatchId2 !== 0) {
      if (rowMatchId1 === 1 && rowMatchId2 === 1) {
        return <JoinFull sx={iconStyle} />;
      }
      if (rowMatchId1 === 1 && rowMatchId2 === 2) {
        return <JoinLeft sx={iconStyle} />;
      }
      if (rowMatchId1 === 2 && rowMatchId2 === 1) {
        return <JoinRight sx={iconStyle} />;
      }
      if (rowMatchId1 === 2 && rowMatchId2 === 2) {
        return <JoinInner sx={iconStyle} />;
      }
    } else return <span style={textStyle}></span>;
  };

  // ====================================== other fnc================

  const onClose = () => {
    setShowRelationCard(false);
    setArrowProp(null);
    setRowUniqueId1(0);
    setRowMatchId1(0);
    setRowUniqueId2(0);
    setRowMatchId2(0);
    setExistingArrow(false);
    setExistingArrowProp(null);
  };

  const FindShowHead = () => {
    if (rowUniqueId2 === 1) {
      return false;
    }
    if (rowUniqueId2 === 2) {
      return true;
    }
    return false;
  };

  const FindShowTail = () => {
    if (rowUniqueId1 === 1) {
      return false;
    }
    if (rowUniqueId1 === 2) {
      return true;
    }
    return false;
  };

  const onSet = () => {
    if (!arrowProp) return;
    if (rowMatchId1 && rowMatchId2 && rowUniqueId1 && rowUniqueId2) {
      const newArrowObj = {
        ...arrowProp,
        isSelected: false,
        integrity: FindIntegrity(rowMatchId1, rowMatchId2),
        cardinality: FindCardinality(rowUniqueId1, rowUniqueId2),
        showHead: FindShowHead(),
        showTail: FindShowTail(),
      };
      dispatch(AddArrow(newArrowObj));
      onClose();
    } else {
      setSeverity('error');
      setTestMessage('please select a value in all the fields');
      setOpenAlert(true);
    }
  };

  const onDelete = () => {
    if (existingArrowProp && existingArrowProp?.isExisting){
      setOpen(true)
      return
    }

    if (existingArrowProp && existingArrowProp.arrowId) {
      dispatch(RemoveArrow(existingArrowProp.arrowId));
      // dispatch(RemoveRelation(existingArrowProp.relationId));
    }
    onClose();
  };

  const onUpdate = () => {
    if (!existingArrowProp) return;
    if (existingArrowProp?.relationId) {
      // dispatch(UpdateRelation(existingArrowProp.relationId, newRelObj));
      dispatch(
        UpdateAllArrowsInRelation(
          existingArrowProp.relationId as string,
          FindCardinality(rowUniqueId1, rowUniqueId2),
          FindIntegrity(rowMatchId1, rowMatchId2),
          FindShowHead(),
          FindShowTail(),
          existingArrowProp.startId,  
          existingArrowProp.endId  
        ),
      );
      onClose();
    }
  };

  var menuStyle: CSS.Properties = { padding: '0.25rem', fontSize: '12px' };

  const TableNames = () => {
    if (arrowProp) {
      const columns = selectedTables.find((table) => table.id === arrowProp.startId)?.columns || [];
      const colType = columns.find((column) => column.uid === arrowProp.start)?.dataType;
      return (
        <React.Fragment>
          <span className="relationPopoverTableHeading" style={{ color: 'rgb(175, 153, 219)' }}>
            {arrowProp.startTableName}
            <div className="">
              <div
                className="relationArrowTableName ellipsis"
                style={{ fontWeight: 'normal', color: 'black' }}
              >
                {itemTypeIcon(colType || '')}
                <span style={{ marginLeft: '0.5rem' }}>{arrowProp.startColumnName}</span>
              </div>
            </div>
          </span>
          <span className="relationPopoverTableHeading" style={{ color: 'rgb(175, 153, 219)' }}>
            {arrowProp.endTableName}
            <div
              className="relationArrowTableName ellipsis"
              style={{ fontWeight: 'normal', color: 'black' }}
            >
              {itemTypeIcon(colType || '')}
              <span style={{ marginLeft: '0.5rem' }}>{arrowProp.endColumnName}</span>
            </div>
          </span>
        </React.Fragment>
      );
    } else if (existingArrowProp) {
      return (
        <React.Fragment>
          <span className="relationPopoverTableHeading" style={{ color: 'rgb(175, 153, 219)' }}>
            {existingArrowProp.startTableName}
            <div className="">
              <div
                className="relationArrowTableName ellipsis"
                style={{ fontWeight: 'normal', color: 'black' }}
              >
                {itemTypeIcon(existingArrowProp.colType ?? '')}
                <span style={{ marginLeft: '0.5rem' }}>{existingArrowProp.startColumnName}</span>
              </div>
            </div>
          </span>
          <span className="relationPopoverTableHeading" style={{ color: 'rgb(175, 153, 219)' }}>
            {existingArrowProp.endTableName}
            <div
              className="relationArrowTableName ellipsis"
              style={{ fontWeight: 'normal', color: 'black' }}
            >
              {itemTypeIcon(existingArrowProp.colType ?? '')}
              <span style={{ marginLeft: '0.5rem' }}>{existingArrowProp.endColumnName}</span>
            </div>
          </span>
        </React.Fragment>
      );
    } else return null;
  };

  return (
    <React.Fragment>
      <Popover
        open={showRelationCard}
        anchorReference="anchorEl"
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        sx={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', fontSize: fontSize.medium }}
      >
        <div className="relationPopover">
          <div className="relationPopoverHeader" style={{ paddingBlock: '0.5rem' }}>
            <span className="relationPopoverHeading">Relationship</span>
            <CloseOutlined
              onClick={onClose}
              sx={{
                cursor: 'pointer',
                borderRadius: '4px',
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.2)', color: 'red' },
              }}
            />
          </div>
          <div className="relationPopoverBody">
            <div className="relationTablesHeading">
              <TableNames />
            </div>
            <div
              className=""
              style={{
                margin: "2rem 1rem",
                boxShadow: '0 0.8px 3px 0.5px rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
              }}
            >
              <div className="relationSelectSection">
                <div className="relationPopoverSideHeading" style={{ fontStyle: 'normal' }}>
                  Uniqueness (Cardinality)
                </div>
                <div style={{ display: 'flex', padding: '0.5rem 1rem 0' }}>
                  <Select
                    // disabled={existingArrowProp?.isExisting}
                    value={rowUniqueId1}
                    fullWidth
                    size="small"
                    sx={{
                      minWidth: '190px',
                      fontSize: '12px',
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                    }}
                    // TODO need to specify type
                    onChange={(e: any) => {
                      setRowUniqueId1(e.target.value);
                    }}
                  >
                    {rowUniqueness.map((el: rowUniq) => {
                      return (
                        <MenuItem
                          style={menuStyle}
                          key={el.id}
                          value={el.id}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(43, 185, 187, 0.1)',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'rgba(43, 185, 187, 0.2)',
                            },
                          }}
                        >
                          {el.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Cardinality />
                  <Select
                    // disabled={existingArrowProp?.isExisting}
                    value={rowUniqueId2}
                    fullWidth
                    size="small"
                    sx={{
                      minWidth: '190px',
                      fontSize: '12px',
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                    }}
                    onChange={(e: any) => {
                      setRowUniqueId2(e.target.value);
                    }}
                  >
                    {rowUniqueness.map((el: rowUniq) => {
                      return (
                        <MenuItem
                          style={menuStyle}
                          key={el.id}
                          value={el.id}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(43, 185, 187, 0.1)',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'rgba(43, 185, 187, 0.2)',
                            },
                          }}
                        >
                          {el.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </div>
              </div>
              <div className="relationSelectSection">
                <div className="relationPopoverSideHeading" style={{ fontStyle: 'normal' }}>
                  Row Match (Referential Integrity)
                </div>
                <div style={{ display: 'flex', padding: '0.5rem 1rem 0' }}>
                  <Select
                    value={rowMatchId1}
                    // disabled={existingArrowProp?.isExisting}
                    fullWidth
                    size="small"
                    sx={{
                      minWidth: '190px',
                      fontSize: '12px',
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                    }}
                    onChange={(e: any) => {
                      setRowMatchId1(e.target.value);
                    }}
                  >
                    {rowMatch.map((el: rowMat) => {
                      return (
                        <MenuItem
                          style={menuStyle}
                          key={el.id}
                          value={el.id}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(43, 185, 187, 0.1)',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'rgba(43, 185, 187, 0.2)',
                            },
                          }}
                        >
                          {el.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Integrity />
                  <Select
                    // disabled={existingArrowProp?.isExisting}
                    value={rowMatchId2}
                    fullWidth
                    size="small"
                    sx={{
                      minWidth: '190px',
                      fontSize: '12px',
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#2bb9bb',
                      },
                    }}
                    onChange={(e: any) => {
                      setRowMatchId2(e.target.value);
                    }}
                  >
                    {rowMatch.map((el: rowMat) => {
                      return (
                        <MenuItem
                          style={menuStyle}
                          key={el.id}
                          value={el.id}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(43, 185, 187, 0.1)',
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'rgba(43, 185, 187, 0.2)',
                            },
                          }}
                        >
                          {el.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </div>
            {/* {existingArrowProp && (
              <RenderArrows
                existingArrowProp={existingArrowProp}
                arrows={arrows}
                deleteSingleArrow={deleteSingleArrow}
                canEdit={canEdit}
              />
            )} */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                paddingBottom: '1rem',
                marginTop: '2rem',
                gap: '3rem',
              }}
            >
              {existingArrowProp ? (
                <HoverButton
                  onClick={onDelete}
                  disabled={!canEdit}
                  text="Remove"
                  color="#484848"
                  hoverColor="white"
                  backgroundColor="white"
                  hoverBackgroundColor="#484848"
                  transitionTime="0.2s"
                  sx={{ border: '2px solid #484848', width: '5rem', fontWeight: 'bold' }}
                />
              ) : (
                <HoverButton
                  onClick={onClose}
                  text="Cancel"
                  color="#484848"
                  hoverColor="white"
                  backgroundColor="white"
                  hoverBackgroundColor="#484848"
                  transitionTime="0.2s"
                  sx={{ border: '2px solid #484848', width: '5rem', fontWeight: 'bold' }}
                />
              )}
              <HoverButton
                onClick={existingArrow ? onUpdate : onSet}
                text="OK"
                color="#484848"
                hoverColor="white"
                backgroundColor="white"
                hoverBackgroundColor="#484848"
                transitionTime="0.2s"
                sx={{ border: '2px solid #484848', width: '5rem', fontWeight: 'bold' }}
              />
            </div>
          </div>
        </div>
      </Popover>
      <NotificationDialog
        onCloseAlert={() => {
          setOpenAlert(false);
          setTestMessage('');
        }}
        openAlert={openAlert}
        severity={severity}
        testMessage={testMessage}
      />

      <ConfirmDialog
        open={open}
        title="Remove Connection ?"
        message="Removing connection may affect the interaction between the tables. Are you sure?"
        confirmText="Remove"
        cancelText="Cancel"
        onConfirm={() => {
          if (existingArrowProp && existingArrowProp.arrowId) {
            dispatch(RemoveArrow(existingArrowProp.arrowId));
          }
          setOpen(false)
          onClose();
        }}
        onCancel={() => setOpen(false)}
      />
    </React.Fragment>
  );
};

// const RenderArrows = ({
//   existingArrowProp,
//   arrows,
//   deleteSingleArrow,
//   canEdit,
// }: {
//   existingArrowProp: ArrowsProps;
//   arrows: ArrowsProps[];
//   deleteSingleArrow: (arrow: ArrowsProps) => void;
//   canEdit?: boolean;
// }) => {
//   var arrowsSubset: ArrowsProps[] = [];
//   if (existingArrowProp) {
//     arrowsSubset = arrows.filter((arr) => arr.relationId === existingArrowProp.relationId);
//   }

//   if (arrowsSubset.length > 0) {
//     return (
//       <div className="relationSelectSection">
//         <div className="relationPopoverSideHeading">Arrows</div>
//         <div className="relationArrowList">
//           {arrowsSubset.map((arrow: ArrowsProps, index: number) => {
//             return (
//               <div className="relationArrow" key={index}>
//                 <div className="relationArrowTableName">{arrow.startColumnName}</div>
//                 <div className="relationArrowTableName">{arrow.endColumnName}</div>
//                 {arrowsSubset.length > 1 ? (
//                   <Delete
//                     sx={{ padding: '4px' }}
//                     onClick={() => canEdit && deleteSingleArrow(arrow)}
//                   />
//                 ) : null}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   } else return null;
// };

export default RelationshipDefiningComponent;
